import * as React from 'react';
import { useGetBuyerQuery } from "../../../apis/Buyer.api";
import { PrimaryBuyer, Buyer } from "../../../types/models/Buyer";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Buyer;
};

export const BuyerNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const BuyerName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetBuyerQuery(PrimaryBuyer.fromId(id))
    return (<BuyerNameDisplay data={data}/>)
}

export default BuyerName;
